// Enum for the different setting types
const calendarAuthHandler = {
  JOBOTI: 'JOBOTI',
  GOOGLE: 'GOOGLE',
  MICROSOFT: 'MICROSOFT',
}

export default calendarAuthHandler
